import { useLocation } from "react-router-dom";
import { urls } from '..';
import { removeMultipleSlashes } from "../data/sport-utils";

export default function useIsLiveSection() {
    let location = useLocation().pathname;
    if (location.endsWith('/')) {
        location = location.slice(0, -1);
    }
    return location.startsWith(removeMultipleSlashes(`${urls.base}/${urls.live.base}`));
}
